/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';
import posthog from 'posthog-js';

type FeatureFlagsProps = {
  children: React.ReactNode;
  showByDefault: boolean;
};

type ContextProps = {
  getFeatureFlag: (flag: string) => any;
  hasFeatureFlag: (flag: string, value: string | string[]) => boolean;
};

const Ctx = createContext<ContextProps>({
  getFeatureFlag: () => {},
  hasFeatureFlag: () => false,
});

export const FeatureFlagsProvider = ({
  children,
  showByDefault,
}: FeatureFlagsProps) => {
  const getFeatureFlag = (flag: string) => {
    return posthog.getFeatureFlagPayload(flag);
  };

  const checkFlag = (flag: string[], value: string) => {
    return flag.find((key) => key === value);
  };

  const hasFeatureFlag = (flag: string, value: string | string[]) => {
    const payload = getFeatureFlag(flag) as string[];

    if (!payload) {
      return showByDefault;
    }

    if (Array.isArray(value)) {
      return value.some((item) => checkFlag(payload, item));
    }
    return !!checkFlag(payload, value);
  };

  return (
    <Ctx.Provider value={{ getFeatureFlag, hasFeatureFlag }}>
      {children}
    </Ctx.Provider>
  );
};

export const useFeatureFlags = () => useContext(Ctx);
